/**
 * Validate a domain name
 * @param {string} domain The domain to validate
 * @returns {boolean} Domain validity
 */
export function validateDomain(domain: string): boolean {
  if (domain.length < 3 || domain.length > 255) return false;
  const domainRegex = /^[a-z0-9]+(?:[-a-z0-9]*\.)+[a-z]{2,}$/i;
  return domainRegex.test(domain);
}

/**
 * Validate a UUID
 * @param {string} uuid The UUID to validate
 * @returns {boolean} UUID validity
 */
export function validateUuid(uuid: string): boolean {
  if (uuid.length > 36) return false;
  const uuidRegex = /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/;
  return uuidRegex.test(uuid);
}

/**
 * Validate a URL
 * @param {string} url The URL to validate
 * @returns {boolean} URL validity
 */
export function validateUrl(url: string): boolean {
  const urlRegex =
    /^https:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/i;
  return urlRegex.test(url);
}
